

// // import React, { useState, useEffect, useLayoutEffect } from 'react';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import { MdLocalOffer } from "react-icons/md";
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
// // import { useForm } from 'react-hook-form';
// // import { zodResolver } from '@hookform/resolvers/zod';
// // import { z } from 'zod';
// // import Spinner from '../component/spinner/spinner'
// // import { GoogleLogin } from '@react-oauth/google';
// // import { jwtDecode } from "jwt-decode";
// // import { toast } from 'react-toastify';
// // import { useAuth } from '../../src/routes/Auth';
// // import { Base_Url, loginapi } from '../config/config';

// // const schema = z.object({
// //   email: z.string().email('Invalid email address').nonempty('Email is required'),
// //   password: z.string().min(6, 'Password must be at least 6 characters long').nonempty('Password is required'),
// //   coupon_code : z.string().optional(),
// // });

// // const LoginPage = ({ setAuth }) => {
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isshowPassword, setIsshowPassword] = useState(false);
// //   const { login } = useAuth();

// //   const navigate = useNavigate();


// //   //  useEffect(()=>{
// //   //   const token=localStorage.getItem('authToken');
// //   //   if(token){
// //   //     navigate('/dashboard')
// //   //   }

// //   // },[])

// //   const { register, handleSubmit, formState: { errors } } = useForm({
// //     resolver: zodResolver(schema),
// //   });



// //   const onSubmit = (data) => {
// //     setIsSubmitting(true)
// //     axios.post(Base_Url + loginapi, {
// //       // axios.post ("http://192.168.1.36/backendci4/api/login",{
// //       username: data.email,
// //       password: data.password,
// //       coupon_code : data.coupon_code,
// //       apply_type : ""
// //     }, {
// //       headers: {
// //         'Content-Type': 'application/json'
// //       }
// //     })
// //       .then(function (response) {
// //         setIsSubmitting(false)

// //         if (response.data.status === 'SUCCESS') {
// //           login(true)
// //           localStorage.setItem('token', response.data.userData.token)
// //           localStorage.setItem('cus_id', response.data.userData.cus_id)
// //           localStorage.setItem('role', response.data.userData.role)
// //           localStorage.setItem('profile_flag', response.data.userData.profile_flag)
// //           localStorage.setItem('wallet_status', response.data.userData.wallet_status)
// //           localStorage.setItem('user', JSON.stringify(response.data));
// //           if (response.data.userData.role !== 'admin') {
// //             if (response.data.userData.profile_flag === '0') {
// //               navigate("/updateKyc");
// //             } else if (response.data.userData.profile_flag === '1') {
// //               navigate("/dashboard");
// //             }
// //           }
// //           toast.success(response.data.message)
// //         }
// //         else {
// //           toast.error(response.data.message);
// //         }
// //       })
// //       .catch(function (error) {
// //         setIsSubmitting(false)

// //       });
// //   }



// //   return (
// //     <section className="flex flex-col items-center justify-center h-full">
// //       <div style={{ backgroundImage: `url('/assets/images/dp.jpg')` }}
// //         className='-z-10 h-full w-full opacity-10 fixed top-0 left-0 pointer-events-none'>
// //       </div>
// //       <div className="text-center mb-4">
// //         <img className="mx-auto" src="/assets/images/logo1.png" width="180" height="150" alt="Logo" />
// //         <h5 className="text-xl font-sans" style={{ fontFamily: 'Open Sans, Public Sans, sans-serif' }}>Login to PICKUPXPRESS</h5>
// //       </div>
// //       <div className="w-950 max-w-md bg-gray-100 p-6 rounded-xl mb-10 border-gray-200 border font-public-sans shadow-lg" >
// //         <form onSubmit={handleSubmit(onSubmit)}>
// //           <div className="relative mb-5 font-public-sans">
// //             <span className="absolute inset-y-0 left-0 flex items-center pl-3">
// //               <FontAwesomeIcon icon={faEnvelope} className="text-black-300" />
// //             </span>
// //             <input
// //               type="text"
// //               className={`w-full pl-10 pr-3 py-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
// //               placeholder="Enter your email *"
// //               {...register('email')}
// //             />
// //             {/* <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-red-500 pointer-events-none">*</span> */}
// //             {errors.email && (
// //               <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
// //                 {errors.email.message}
// //               </p>
// //             )}
// //           </div>

// //           <div className="relative mb-5 font-public-sans">
// //             <span className="absolute inset-y-0 left-0 flex items-center pl-3">
// //               <FontAwesomeIcon icon={faLock} className="text-black-300" />
// //             </span>
// //             <input
// //               type={isshowPassword ? 'text' : 'password'}
// //               className={`w-full pl-10 pr-10 py-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
// //               placeholder="Enter your password *"
// //               {...register('password')}
// //             />
// //             {/* <span className="absolute inset-y-0 right-10 flex items-center pr-3 text-red-500 pointer-events-none">*</span> */}
// //             <span
// //               className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
// //               onClick={() => setIsshowPassword(!isshowPassword)}
// //             >
// //               <FontAwesomeIcon icon={isshowPassword ? faEye : faEyeSlash} />
// //             </span>
// //             {errors.password && (
// //               <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
// //                 {errors.password.message}
// //               </p>
// //             )}
// //           </div>

// //         <div className="relative mb-5 font-public-sans">
// //             <span className="absolute inset-y-0 left-0 flex items-center pl-3">
// //               <MdLocalOffer icon={faEnvelope} className="text-black-300" />
// //             </span>
// //             <input
// //               type="text"
// //               className={`w-full pl-10 pr-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
// //               placeholder="Enter your code"
// //               {...register('coupon_code')}
// //             />
// //           </div>
          
// //           <button
// //             className="w-full bg-blueMain text-white py-2 px-4 rounded-md hover:bg-blue-600 text-sm font-open-sans font-bold items-center justify-center flex"
// //             type="submit"
// //             disabled={isSubmitting}

// //           >
// //             {isSubmitting ? <Spinner /> : 'SIGN IN'}
// //           </button>
// //           <div className="text-center mt-4">
// //             <a href="/forgot-password" className="text-black hover:text-blueMain text-xs font-open-sans font-semibold">
// //               FORGOT PASSWORD
// //             </a>
// //           </div>
// //           <div className="text-center mt-4 flex items-center justify-center">
// //             <span className="border-t border-darkBlue flex-grow h-0.5"></span>
// //             <span className="text-white font-bold font-open-sans w-100 h-100 px-2 py-1 rounded-full bg-darkBlue text-md">or</span>
// //             <span className="border-t border-darkBlue flex-grow h-0.5"></span>
// //           </div>
// //         </form>
// //       </div>
// //       <div className="max-w-md bg-gray-100 p-6 rounded-xl mb-5 md:mb-0 lg:mb-8  border font-public-sans shadow-lg w-950">
// //         <span className="text-black">
// //           Don't have an account? {'  '}
// //           <a href="/register" className="text-blue-500 hover:underline">
// //             Register
// //           </a>
// //         </span>
// //       </div>
// //     </section>
// //   );
// // };

// // export default LoginPage;


import { useState, useEffect } from "react";
import { Mail, Lock, EyeOff, Eye, Truck, Package, Zap } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../src/routes/Auth";
import { Base_Url, loginapi } from "../config/config";

export default function LoginPage() {

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const LoginApi = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(
        Base_Url + loginapi,
        {
          username: email,
          password: password,
          coupon_code: "",
          apply_type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setIsSubmitting(false);

      if (response.data.status === "SUCCESS") {
        login(true);

        localStorage.setItem("token", response.data.userData.token);
        localStorage.setItem("cus_id", response.data.userData.cus_id);
        localStorage.setItem("role", response.data.userData.role);
        localStorage.setItem("profile_flag", response.data.userData.profile_flag);
        localStorage.setItem("wallet_status", response.data.userData.wallet_status);
        localStorage.setItem("user", JSON.stringify(response.data));

        if (response.data.userData.role !== "admin") {
          if (response.data.userData.profile_flag === "0") {
            navigate("/updateKyc");
          } else if (response.data.userData.profile_flag === "1") {
            navigate("/dashboard");
          }
        }

        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }

    } catch (error) {
      setIsSubmitting(false);
      toast.error("Something went wrong!");
      console.error(error);
    }
  };

  return (
  <>
           <style>{`
                @keyframes blobFloat {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    50%      { transform: translate(20px, -25px) scale(1.08); }
                }
                @keyframes gradientShift {
                    0%, 100% { background-position: 0% 50%; }
                    50%      { background-position: 100% 50%; }
                }
                @keyframes glowPulse {
                    0%, 100% { box-shadow: 0 0 0 0 rgba(249,115,22,0); }
                    50%      { box-shadow: 0 0 35px 6px rgba(249,115,22,0.22); }
                }
                @keyframes shimmerSweep {
                    0%   { transform: translateX(-120%) skewX(-15deg); }
                    100% { transform: translateX(220%) skewX(-15deg); }
                }

                .blob-float    { animation: blobFloat 9s ease-in-out infinite; }
                .gradient-anim { background-size: 200% 200%; animation: gradientShift 5s ease infinite; }
                .glow-card     { animation: glowPulse 3.2s ease-in-out infinite; }

                .shimmer-btn { position: relative; overflow: hidden; }
                .shimmer-btn::after {
                    content: '';
                    position: absolute;
                    top: 0; left: 0;
                    width: 40%; height: 100%;
                    background: linear-gradient(120deg, transparent, rgba(255,255,255,0.45), transparent);
                    animation: shimmerSweep 2.4s ease-in-out infinite;
                }
            `}</style>
    <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">

      <img
        src="assets/images/login-bg.png"
        alt="bg"
        className="absolute w-full h-full object-cover animate-[zoomBg_10s_ease-in-out_infinite]"
      />

      <div className="absolute inset-0 bg-white/60 "></div>

      <div className="relative w-full max-w-6xl flex items-center justify-around px-6">

        <div
          data-aos="fade-right"
          className="hidden md:flex flex-col max-w-md text-left"
        >
          <h1 className="text-4xl font-bold leading-tight text-gray-800">
            Delivering Excellence, <br />
            <span className="text-red-600">Driving Growth.</span>
          </h1>

          <p className="text-gray-600 mt-4">
            Smart logistics solutions to move your business forward.
          </p>

          <div className="mt-8 space-y-6">

            {[
              { icon: <Truck />, title: "Fast Delivery", desc: "Timely shipments worldwide." },
              { icon: <Package />, title: "Secure Handling", desc: "Safe order handling." },
              { icon: <Zap />, title: "Smart Solutions", desc: "Tech-driven logistics." },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-4 group hover:translate-x-2 transition duration-300">
                <div className="border border-red-400 p-2 rounded-lg group-hover:bg-red-500 transition">
                  <div className="text-red-500 group-hover:text-white">
                    {item.icon}
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold">{item.title}</h4>
                  <p className="text-sm text-gray-700">{item.desc}</p>
                </div>
              </div>
            ))}

          </div>
        </div>

        <div
          data-aos="zoom-in"
          className="w-full max-w-md bg-white/80 backdrop-blur-lg rounded-2xl shadow-2xl p-6 border border-gray-200 hover:scale-[1.02] transition duration-300"
        >

          <div className="text-center  mb-2">
            <img
              src="assets/images/logo1.png"
              className="mx-auto w-48 rounded-sm "
              alt="PickupXpress"
            />
            <p className="text-gray-500 text-sm">
              Smart Logistics for Modern Businesses 🚚
            </p>
          </div>

          <h2 className="text-xl font-semibold mb-4 text-center">
            Login to your account
          </h2>

          <div className="mb-3">
            <label className="text-sm text-gray-700 font-medium">Email</label>

            <div className="flex items-center border rounded-lg px-3 py-3 mt-1 focus-within:ring-2 focus-within:ring-red-400 transition">
              <Mail size={18} className="text-gray-400 mr-2" />
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full outline-none text-sm bg-transparent"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="text-sm text-gray-700 font-medium">Password</label>

            <div className="flex items-center border rounded-lg px-3 py-3 mt-1 focus-within:ring-2 focus-within:ring-red-400 transition">
              <Lock size={18} className="text-gray-400 mr-2" />

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full outline-none text-sm bg-transparent"
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                className="cursor-pointer text-gray-400 hover:text-red-500 transition"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center mb-5 text-sm">
            <label className="flex items-center gap-2 text-gray-600">
              <input type="checkbox" />
              Remember me
            </label>

            <Link to="/forget-password" className="text-blue-600 cursor-pointer hover:underline">
              Forgot password?
            </Link>
          </div>

          <button
            onClick={LoginApi}
            disabled={isSubmitting}
            className="w-full bg-red-600 text-white py-3 shimmer-btn transition-all duration-300 hover:bg-red-600 hover:scale-[1.02] hover:shadow-lg active:scale-[0.98] rounded-lg font-medium  hover:shadow-red-300 "
          >
            {isSubmitting ? "Loading..." : "Login"}
          </button>

          <p className="text-center text-sm text-gray-500 mt-3">
            Don’t have an account?{" "}
            <Link to="/register" className="text-blue-600 font-medium">
              Register
            </Link>
          </p>
        </div>

      </div>

      <style>
        {`
          @keyframes zoomBg {
            0%,100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
        `}
      </style>

    </div>
  </>
  );
}